<template>
  <modal :show="show" @change="$emit('change', $event)" width="650">
    <template v-slot:header>
      <span>{{ header }}</span>
    </template>
    <template v-slot:main>
      <div class="modal-info mx-7">
        <div v-html="text" class="d-block my-5 fs-18">
        </div>
      </div>
      <br/>
    </template>
  </modal>
</template>

<script>
import Modal from "../common/Modal";
import { mask } from "vue-the-mask";

export default {
  name: "ModalNoElectricity",
  directives: {
    mask,
  },
  components: {
    Modal,
  },
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "",
    },
    header: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    message: "",
  }),
  computed: {},
  methods: {},
};
</script>

<style lang="scss">
.modal-info {
  min-height: 200px;
  //display: flex;
  //flex-direction: column;

  &__message {
    margin: auto;
  }
}

.orange--checkbox {
  color: green !important;

  .accent--text {
    i {
      color: green !important;
    }
  }

  .v-application .accent--text {
    color: green !important;
  }
}
